module.exports = __webpack_public_path__ + "img/no-notes.d0de38e.png";